import React from 'react'
import { useTranslation } from 'react-i18next'
import { LanguageSelector } from './LanguageSelector'
import {
  Layout,
  StyledHeader,
  LogoContainer,
  HeaderActionsContainer,
  UserMenu,
  UserName,
  UserMeta,
  Main,
} from './PublicLayout.styles'

interface PublicLayoutProps {
  children: React.ReactNode
  /** User full name (e.g., "John Doe") */
  title?: string
  subtitle?: string
  logo?: string
  /** Office or company name */
  companyName?: string
  /** Office name (takes precedence over companyName for display) */
  officeName?: string
  creationDate?: string
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({
  children,
  title,
  logo,
  companyName,
  officeName,
  creationDate,
}) => {
  const { t } = useTranslation()

  const brandName = officeName || companyName || t('common.app_name')
  const customLogo = logo || '/images/popety-io-logo.png'

  // Format the creation date nicely
  const formattedDate = creationDate
    ? new Date(creationDate).toLocaleDateString('fr-CH', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    : ''

  const headerLogo = (
    <LogoContainer>
      <img src={customLogo} alt={brandName} />
    </LogoContainer>
  )

  const headerActions = (
    <HeaderActionsContainer>
      <UserMenu aria-label="right menu" role="navigation">
        {formattedDate ? (
          <UserMeta>{t('common.shared_on', { date: formattedDate })}</UserMeta>
        ) : null}
        {title ? (
          <UserName>{t('common.shared_by', { name: title })}</UserName>
        ) : null}
      </UserMenu>
      <LanguageSelector />
    </HeaderActionsContainer>
  )

  return (
    <Layout>
      <StyledHeader
        logo={headerLogo}
        actions={headerActions}
        navItems={[]}
        sticky={true}
        showSearch={false}
      />

      <Main>{children}</Main>
    </Layout>
  )
}
